module.exports = __webpack_public_path__ + "img/深圳市儿童医院.8f16172d.png";